import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from '@/store/swine';
import { FlooringType } from "@/models/swine/flooringTypes/flooringTypes.model";
import { axios } from "@/utils/axios";
import { Endpoints } from "@/utils/endpoints";

@Module({
    namespaced: true,
    dynamic: true,
    name: 'flooring-types.list',
    store,
})
class FlooringTypesListStore extends VuexModule {
    response: FlooringType[] = [];
    isLoading = false;
    error: any | null = null;

    @Mutation
    updateLoadingStatus(payload: boolean) {
        this.isLoading = payload;
    }

    @Mutation
    setError(error: any) {
        this.error = error;
    }

    @Mutation
    setResponse(payload: FlooringType[]) {
        this.response.splice(0, this.response.length);
        payload.forEach((item) => {
            this.response.push(item);
        });
    }

    @Action
    getFlooringTypes() {
        this.context.commit('updateLoadingStatus', true);
        this.context.commit('setError', null);
        try {
            axios.get(`${Endpoints.FlooringTypes}`)
                .then((response) => {
                    this.context.commit('setResponse', response.data);
                })
        } catch (error) {
            this.context.commit('setError', error);
        }
        this.context.commit('updateLoadingStatus', false);
    }

}

export default getModule(FlooringTypesListStore);